import { render, staticRenderFns } from "./formInputTextArea.vue?vue&type=template&id=f47679a0&"
import script from "./formInputTextArea.vue?vue&type=script&lang=js&"
export * from "./formInputTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports